<app-page-title [title]="'Text Message Notifications'"></app-page-title>
<div class="form-container">
    <form
        name="notification-setting-form"
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()"
    >
        <app-sms-notification-consent [formGroup]="formGroup"></app-sms-notification-consent>
        <button
            [disabled]="!formGroup.valid &&
            (!formGroup.controls.smsPhoneNumber.value ||
            (formGroup.controls.smsPhoneNumber.value.e164Number.length !== 12 || formGroup.controls.smsPhoneNumber.value.e164Number.indexOf('753') !== 2))"
            name="confirmationYesBtn"
            type="submit"
            class="btn btn-primary has-spinner"
        >
            Save
        </button>
    </form>
</div>
